function normalizeBaseUrl(value) {
  const trimmed = String(value || '').trim()
  if (!trimmed) return ''
  if (trimmed === '/') return '/'
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`
}

export const API_BASE_URL = normalizeBaseUrl(process.env.VUE_APP_API_BASE_URL)

export function apiUrl(path) {
  if (!path) return API_BASE_URL || '/'

  // 已是绝对地址
  if (/^https?:\/\//i.test(path)) return path

  // 没配置 base：走相对路径（正式环境通常同域部署/由网关转发）
  if (!API_BASE_URL) return path

  // base 是相对路径（例如 '/' 或 '/api/'）：在浏览器里补齐 origin
  if (!/^https?:\/\//i.test(API_BASE_URL)) {
    if (typeof window !== 'undefined' && window.location?.origin) {
      const base = `${window.location.origin}${API_BASE_URL.startsWith('/') ? '' : '/'}${API_BASE_URL}`
      return new URL(path, base).toString()
    }
    return `${API_BASE_URL.replace(/\/$/, '')}${path.startsWith('/') ? '' : '/'}${path}`
  }

  return new URL(path, API_BASE_URL).toString()
}
